/**
 * Agency type constants and labels for Master Data Agencies UI.
 * Must match backend config/agencyTypes.js values.
 */
export const AGENCY_TYPES = [
  'STORE_SUPPLIER',
  'COMPONENT_AGENCY',
  'EXTERNAL_MAINTENANCE',
  'TRANSPORTATION',
  'HOTEL',
  'BILL_TO',
  'SHIP_TO'
];

export const AGENCY_TYPE_LABELS = {
  STORE_SUPPLIER: 'Supplier for Store',
  COMPONENT_AGENCY: 'Agency for Component',
  EXTERNAL_MAINTENANCE: 'External Maintenance Agency',
  TRANSPORTATION: 'Transportation Agency',
  HOTEL: 'Hotel',
  BILL_TO: 'Bill To',
  SHIP_TO: 'Ship To'
};

export function getAgencyTypeLabel(value) {
  return AGENCY_TYPE_LABELS[value] || value;
}
